module.exports = __webpack_public_path__ + "img/accounts.155f7e44.png";